import { useQuery } from "@tanstack/react-query";
import responseTemplatesService from "services/admin/responseTemplatesService";
import { ResponseTemplate } from "interfaces/entities/responseTemplate.model";

interface ResponseTemplatesQuery {
    language?: string;
    search?: string;
    limit?: number;
}

export const useGetResponseTemplates = (queryParams: ResponseTemplatesQuery = {}) => {
    return useQuery({
        queryKey: ["response-templates", queryParams],
        queryFn: async () => {
            const response = await responseTemplatesService.getAll(queryParams);
            return (response as any)?.data as ResponseTemplate[] | undefined;
        },
    });
};
